import { apiClient } from "shared/utils";
import { SubscriptionReportRequest } from "api/models";

export const postSubscriptionReport = async ({ shopId, ...values }: SubscriptionReportRequest) => {
  const { data } = await apiClient.post<void>(`/${shopId}/reports/subscriptions/submit`, values);

  return data;
};
